import { render } from "./team-logo-opacity.vue?vue&type=template&id=26cf1ed8&scoped=true"
import script from "./team-logo-opacity.vue?vue&type=script&lang=js"
export * from "./team-logo-opacity.vue?vue&type=script&lang=js"

import "./team-logo-opacity.vue?vue&type=style&index=0&id=26cf1ed8&scoped=true&lang=scss"

import exportComponent from "/var/lib/buildkite-agent/builds/assemble-builder/assemble-sports/oztagaustralia-livescores-production-vertical-traffic-light/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26cf1ed8"]])

export default __exports__